import {
  FaInstagram,
  FaXTwitter,
  FaLinkedinIn,
  FaTiktok,
} from "react-icons/fa6";
import { FaMedium } from "react-icons/fa";

export const ListIcon = [
  {
    url: "https://www.instagram.com/ristek.csui/",
    icon: FaInstagram,
  },
  {
    url: "https://twitter.com/RistekCSUI",
    icon: FaXTwitter,
  },
  {
    url: "https://www.linkedin.com/company/ristek-fasilkom-universitas-indonesia",
    icon: FaLinkedinIn,
  },
  {
    url: "https://liff.line.me/1645278921-kWRPP32q?accountId=rye2953f&openerPlatform=webview&openerKey=webview%3AunifiedSearch",
    icon: FaTiktok,
  },
  {
    url: "https://medium.com/ristek-fasilkom",
    icon: FaMedium,
  },
];
